"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.User = void 0;

var User =
/** @class */
function () {
  function User(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - removeUserId
   * @param string - requestUserId
   * @param string - poolId
   * @return Promise|Observable|any
   */


  User.prototype.CheckIfUserCanBeRemovedFromPool = function (removeUserId, requestUserId, poolId) {
    return this.restClient.get('User/UseCase/CheckIfUserCanBeRemovedFromPool', {
      removeUserId: removeUserId,
      requestUserId: requestUserId,
      poolId: poolId
    });
  };
  /**
   * @param string - userId
   * @param string[]? - withData UserName|UserAddress|UserToken|UserIdentifier|isEFAdmin|internalUserName
   * @param any[]? - withUserAttributes internal|info|hover|facebook|linked-in|salesforce|twitter|convio|google|custom|virbela|healthpass
   * @param string? - poolId
   * @return Promise|Observable|any
   */


  User.prototype.GetUser = function (userId, withData, withUserAttributes, poolId) {
    if (withData === void 0) {
      withData = null;
    }

    if (withUserAttributes === void 0) {
      withUserAttributes = null;
    }

    if (poolId === void 0) {
      poolId = null;
    }

    return this.restClient.get('User/UseCase/GetUser', {
      userId: userId,
      withData: withData,
      withUserAttributes: withUserAttributes,
      poolId: poolId
    });
  };
  /**
   * @param string - email
   * @param string[]? - withData UserName|UserAddress|UserToken|isEFAdmin|internalUserName
   * @param any[]? - withUserAttributes internal|info|hover|facebook|linked-in|salesforce|twitter|convio|google|custom|virbela|healthpass
   * @param string? - poolId
   * @return Promise|Observable|any
   */


  User.prototype.GetUserByEmail = function (email, withData, withUserAttributes, poolId) {
    if (withData === void 0) {
      withData = null;
    }

    if (withUserAttributes === void 0) {
      withUserAttributes = null;
    }

    if (poolId === void 0) {
      poolId = null;
    }

    return this.restClient.get('User/UseCase/GetUserByEmail', {
      email: email,
      withData: withData,
      withUserAttributes: withUserAttributes,
      poolId: poolId
    });
  };
  /**
   * @param string - poolId
   * @param string - userId
   * @param string[]? - withData UserName|UserAddress|UserToken|UserIdentifier|isEFAdmin|internalUserName|UserHealthPass
   * @param any[]? - withUserAttributes internal|info|hover|facebook|linked-in|salesforce|twitter|convio|google|custom|virbela|healthpass
   * @return Promise|Observable|any
   */


  User.prototype.GetUserInPool = function (poolId, userId, withData, withUserAttributes) {
    if (withData === void 0) {
      withData = null;
    }

    if (withUserAttributes === void 0) {
      withUserAttributes = null;
    }

    return this.restClient.get('User/UseCase/GetUserInPool', {
      poolId: poolId,
      userId: userId,
      withData: withData,
      withUserAttributes: withUserAttributes
    });
  };
  /**
   * @param string - userId
   * @param string - eventId
   * @return Promise|Observable|any
   */


  User.prototype.GetUserRolesForEvent = function (userId, eventId) {
    return this.restClient.get('User/UseCase/GetUserRolesForEvent', {
      userId: userId,
      eventId: eventId
    });
  };
  /**
   * @param string - userId
   * @param string - ticketBlockId
   * @return Promise|Observable|any
   */


  User.prototype.GetUserRolesForTicketBlock = function (userId, ticketBlockId) {
    return this.restClient.get('User/UseCase/GetUserRolesForTicketBlock', {
      userId: userId,
      ticketBlockId: ticketBlockId
    });
  };
  /**
   * @param string - exhibitorId
   * @param string - poolId
   * @param string[]? - withData UserIdentifiers|UserNames|UserAttributes
   * @param string? - query
   * @param string? - sortBy name
   * @param string? - sortDirection ascending|descending
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @return Promise|Observable|any
   */


  User.prototype.ListUsersForExhibitor = function (exhibitorId, poolId, withData, query, sortBy, sortDirection, page, itemsPerPage) {
    if (withData === void 0) {
      withData = null;
    }

    if (query === void 0) {
      query = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    return this.restClient.get('User/UseCase/ListUsersForExhibitor', {
      exhibitorId: exhibitorId,
      poolId: poolId,
      withData: withData,
      query: query,
      sortBy: sortBy,
      sortDirection: sortDirection,
      page: page,
      itemsPerPage: itemsPerPage
    });
  };
  /**
   * @param any[] - poolIds
   * @param string[]? - withData UserIdentifiers|UserNames|UserAttributes
   * @param string? - query
   * @param string? - sortBy name
   * @param string? - sortDirection ascending|descending
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @return Promise|Observable|any
   */


  User.prototype.ListUsersForPools = function (poolIds, withData, query, sortBy, sortDirection, page, itemsPerPage) {
    if (withData === void 0) {
      withData = null;
    }

    if (query === void 0) {
      query = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    return this.restClient.get('User/UseCase/ListUsersForPools', {
      poolIds: poolIds,
      withData: withData,
      query: query,
      sortBy: sortBy,
      sortDirection: sortDirection,
      page: page,
      itemsPerPage: itemsPerPage
    });
  };
  /**
   * @param string - ticketBlockId
   * @param string[]? - withData UserIdentifiers|UserNames|UserAttributes
   * @param string? - query
   * @param string? - sortBy name
   * @param string? - sortDirection ascending|descending
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @return Promise|Observable|any
   */


  User.prototype.ListUsersForTicketBlock = function (ticketBlockId, withData, query, sortBy, sortDirection, page, itemsPerPage) {
    if (withData === void 0) {
      withData = null;
    }

    if (query === void 0) {
      query = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    return this.restClient.get('User/UseCase/ListUsersForTicketBlock', {
      ticketBlockId: ticketBlockId,
      withData: withData,
      query: query,
      sortBy: sortBy,
      sortDirection: sortDirection,
      page: page,
      itemsPerPage: itemsPerPage
    });
  };
  /**
   * @param string - groupId
   * @param string - poolId
   * @param string[]? - withData UserIdentifiers|UserNames|UserAttributes
   * @param string? - query
   * @param string? - sortBy name
   * @param string? - sortDirection ascending|descending
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @return Promise|Observable|any
   */


  User.prototype.ListUsersInGroup = function (groupId, poolId, withData, query, sortBy, sortDirection, page, itemsPerPage) {
    if (withData === void 0) {
      withData = null;
    }

    if (query === void 0) {
      query = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    return this.restClient.get('User/UseCase/ListUsersInGroup', {
      groupId: groupId,
      poolId: poolId,
      withData: withData,
      query: query,
      sortBy: sortBy,
      sortDirection: sortDirection,
      page: page,
      itemsPerPage: itemsPerPage
    });
  };
  /**
   * @param string - eventId
   * @param string[]? - withData eventRoles|PoolContacts|UserIdentifiers|UserNames|UserAttributes
   * @param string? - query
   * @param string? - sortBy name
   * @param string? - sortDirection ascending|descending
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @return Promise|Observable|any
   */


  User.prototype.ListUsersWithRolesForEvent = function (eventId, withData, query, sortBy, sortDirection, page, itemsPerPage) {
    if (withData === void 0) {
      withData = null;
    }

    if (query === void 0) {
      query = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    return this.restClient.get('User/UseCase/ListUsersWithRolesForEvent', {
      eventId: eventId,
      withData: withData,
      query: query,
      sortBy: sortBy,
      sortDirection: sortDirection,
      page: page,
      itemsPerPage: itemsPerPage
    });
  }; // Commands

  /**
   * @param string - userId
   * @param string - token
   * @return Promise|Observable|any
   */


  User.prototype.AccessUserForgotPasswordToken = function (userId, token) {
    return this.restClient.post('User/UseCase/AccessUserForgotPasswordToken', {
      userId: userId,
      token: token
    });
  };
  /**
   * @param string - userId
   * @param string - groupId
   * @return Promise|Observable|any
   */


  User.prototype.AddUserAccessToGroup = function (userId, groupId) {
    return this.restClient.post('User/UseCase/AddUserAccessToGroup', {
      userId: userId,
      groupId: groupId
    });
  };
  /**
   * @param string? - email
   * @param string? - firstName
   * @param string? - lastName
   * @param string? - company
   * @param string? - position
   * @param string? - phone
   * @param string? - poolId
   * @param string? - title
   * @param string? - other
   * @return Promise|Observable|any
   */


  User.prototype.CreateAuthUser = function (email, firstName, lastName, company, position, phone, poolId, title, other) {
    if (email === void 0) {
      email = null;
    }

    if (firstName === void 0) {
      firstName = null;
    }

    if (lastName === void 0) {
      lastName = null;
    }

    if (company === void 0) {
      company = null;
    }

    if (position === void 0) {
      position = null;
    }

    if (phone === void 0) {
      phone = null;
    }

    if (poolId === void 0) {
      poolId = null;
    }

    if (title === void 0) {
      title = null;
    }

    if (other === void 0) {
      other = null;
    }

    return this.restClient.post('User/UseCase/CreateAuthUser', {
      email: email,
      firstName: firstName,
      lastName: lastName,
      company: company,
      position: position,
      phone: phone,
      poolId: poolId,
      title: title,
      other: other
    });
  };
  /**
   * @param string? - email
   * @param string? - firstName
   * @param string? - lastName
   * @param string? - company
   * @param string? - position
   * @param string? - phone
   * @param string? - title
   * @param string? - other
   * @param string? - userId
   * @param string? - poolId
   * @return Promise|Observable|any
   */


  User.prototype.CreateCIOAccount = function (email, firstName, lastName, company, position, phone, title, other, userId, poolId) {
    if (email === void 0) {
      email = null;
    }

    if (firstName === void 0) {
      firstName = null;
    }

    if (lastName === void 0) {
      lastName = null;
    }

    if (company === void 0) {
      company = null;
    }

    if (position === void 0) {
      position = null;
    }

    if (phone === void 0) {
      phone = null;
    }

    if (title === void 0) {
      title = null;
    }

    if (other === void 0) {
      other = null;
    }

    if (userId === void 0) {
      userId = null;
    }

    if (poolId === void 0) {
      poolId = null;
    }

    return this.restClient.post('User/UseCase/CreateCIOAccount', {
      email: email,
      firstName: firstName,
      lastName: lastName,
      company: company,
      position: position,
      phone: phone,
      title: title,
      other: other,
      userId: userId,
      poolId: poolId
    });
  };
  /**
   * @param string - userId
   * @return Promise|Observable|any
   */


  User.prototype.CreateForgotPasswordToken = function (userId) {
    return this.restClient.post('User/UseCase/CreateForgotPasswordToken', {
      userId: userId
    });
  };
  /**
   * @param string? - email
   * @param string? - firstName
   * @param string? - lastName
   * @param string? - company
   * @param string? - position
   * @param string? - phone
   * @param string? - poolId
   * @param string? - title
   * @param string? - other
   * @return Promise|Observable|any
   */


  User.prototype.CreateUser = function (email, firstName, lastName, company, position, phone, poolId, title, other) {
    if (email === void 0) {
      email = null;
    }

    if (firstName === void 0) {
      firstName = null;
    }

    if (lastName === void 0) {
      lastName = null;
    }

    if (company === void 0) {
      company = null;
    }

    if (position === void 0) {
      position = null;
    }

    if (phone === void 0) {
      phone = null;
    }

    if (poolId === void 0) {
      poolId = null;
    }

    if (title === void 0) {
      title = null;
    }

    if (other === void 0) {
      other = null;
    }

    return this.restClient.post('User/UseCase/CreateUser', {
      email: email,
      firstName: firstName,
      lastName: lastName,
      company: company,
      position: position,
      phone: phone,
      poolId: poolId,
      title: title,
      other: other
    });
  };
  /**
   * @param string - userId
   * @param string - poolId
   * @param string - email
   * @param string? - userContactAgentId
   * @return Promise|Observable|any
   */


  User.prototype.CreateUserContactAgent = function (userId, poolId, email, userContactAgentId) {
    if (userContactAgentId === void 0) {
      userContactAgentId = null;
    }

    return this.restClient.post('User/UseCase/CreateUserContactAgent', {
      userId: userId,
      poolId: poolId,
      email: email,
      userContactAgentId: userContactAgentId
    });
  };
  /**
   * @param string - userId
   * @param string - eventId
   * @return Promise|Observable|any
   */


  User.prototype.RemoveEventRoleForUser = function (userId, eventId) {
    return this.restClient.post('User/UseCase/RemoveEventRoleForUser', {
      userId: userId,
      eventId: eventId
    });
  };
  /**
   * @param string - userId
   * @param string - groupId
   * @return Promise|Observable|any
   */


  User.prototype.RemoveUserAccessToGroup = function (userId, groupId) {
    return this.restClient.post('User/UseCase/RemoveUserAccessToGroup', {
      userId: userId,
      groupId: groupId
    });
  };
  /**
   * @param string - userContactAgentId
   * @return Promise|Observable|any
   */


  User.prototype.RemoveUserContactAgent = function (userContactAgentId) {
    return this.restClient.post('User/UseCase/RemoveUserContactAgent', {
      userContactAgentId: userContactAgentId
    });
  };
  /**
   * @param any[] - removeUserIds
   * @param string - requestUserId
   * @param string - poolId
   * @return Promise|Observable|any
   */


  User.prototype.RemoveUsersFromPool = function (removeUserIds, requestUserId, poolId) {
    return this.restClient.post('User/UseCase/RemoveUsersFromPool', {
      removeUserIds: removeUserIds,
      requestUserId: requestUserId,
      poolId: poolId
    });
  };
  /**
   * @param string - email
   * @param string? - appName
   * @return Promise|Observable|any
   */


  User.prototype.SendForgotPasswordEmail = function (email, appName) {
    if (appName === void 0) {
      appName = null;
    }

    return this.restClient.post('User/UseCase/SendForgotPasswordEmail', {
      email: email,
      appName: appName
    });
  };
  /**
   * @param string - email
   * @param string? - appName
   * @return Promise|Observable|any
   */


  User.prototype.SendVerificationEmail = function (email, appName) {
    if (appName === void 0) {
      appName = null;
    }

    return this.restClient.post('User/UseCase/SendVerificationEmail', {
      email: email,
      appName: appName
    });
  };
  /**
   * @param string - invitationId
   * @param string - authUserId
   * @param string - changeUserId
   * @param string - email
   * @return Promise|Observable|any
   */


  User.prototype.SetEmailForInvitation = function (invitationId, authUserId, changeUserId, email) {
    return this.restClient.post('User/UseCase/SetEmailForInvitation', {
      invitationId: invitationId,
      authUserId: authUserId,
      changeUserId: changeUserId,
      email: email
    });
  };
  /**
   * @param string - userId
   * @param string - eventId
   * @param string - eventRole organizer|assistant|support|check-in-staff|read-only
   * @param string - authenticatedUserId
   * @return Promise|Observable|any
   */


  User.prototype.SetEventRoleForUser = function (userId, eventId, eventRole, authenticatedUserId) {
    return this.restClient.post('User/UseCase/SetEventRoleForUser', {
      userId: userId,
      eventId: eventId,
      eventRole: eventRole,
      authenticatedUserId: authenticatedUserId
    });
  };
  /**
   * @param string - userContactAgentId
   * @param string - email
   * @return Promise|Observable|any
   */


  User.prototype.UpdateUserContactAgent = function (userContactAgentId, email) {
    return this.restClient.post('User/UseCase/UpdateUserContactAgent', {
      userContactAgentId: userContactAgentId,
      email: email
    });
  };

  return User;
}();

exports.User = User;